import React from "react";
import { ShoppingCart, Users, Award, SlidersHorizontal, ShieldCheck, CheckCircle2, Truck, Clock } from "lucide-react";
import { company, stats } from "../mock";

const iconMap = { ShoppingCart, Users, Award, SlidersHorizontal, ShieldCheck, CheckCircle2, Truck, Clock };

const Numbers = () => {
  return (
    <section className="bg-[#0f2846] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-white text-3xl md:text-4xl font-bold">I numeri di {company.shortName}</h2>
          <div className="w-24 h-1 bg-[#e8464a] mx-auto mt-4 rounded-full" />
          <p className="text-white/60 mt-5">16 anni di esperienza tradotti in dati concreti.</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-12">
          {stats.map((s, i) => {
            const Ic = iconMap[s.icon];
            return (
              <div key={i} className="rounded-2xl bg-white/[0.04] border border-white/10 p-6 text-center hover:bg-white/[0.08] hover:-translate-y-1 transition-all">
                <Ic size={30} className="text-[#5b8fd6] mx-auto" strokeWidth={1.6} />
                <div className="font-display text-white text-3xl md:text-4xl font-bold mt-3">{s.value}</div>
                <div className="text-white/70 text-sm mt-1">{s.label}</div>
                {s.sub && <div className="text-white/40 text-xs">{s.sub}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Numbers;
